export const aciReduce = {
    iconName: 'reduce',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M20.38 3.012a.396.396 0 00-.087.04c-.026.016-1.412 1.391-3.08 3.057l-3.03 3.027v-4.06l-.045-.096a.545.545 0 00-.254-.251.645.645 0 00-.334-.007.53.53 0 00-.279.257l-.045.097V10.405l.053.103c.06.114.178.215.287.246.099.027 5.291.027 5.39 0a.501.501 0 00.288-.247c.117-.23.043-.482-.184-.63l-.08-.051-2.058-.006-2.058-.005 3.03-3.03c2.376-2.377 3.037-3.049 3.068-3.117a.546.546 0 00.003-.393.527.527 0 00-.241-.241.699.699 0 00-.345-.022zM4.99 13.265a.477.477 0 00-.227.2c-.044.067-.05.095-.05.239 0 .143.006.171.05.239a.477.477 0 00.228.2c.085.038.114.039 2.116.039h2.03l-3.03 3.031c-2.378 2.379-3.038 3.05-3.069 3.117a.557.557 0 00-.01.379c.04.094.153.21.249.255a.54.54 0 00.392-.003c.068-.03.74-.692 3.117-3.069l3.03-3.03v2.03l.001 2.03.045.096a.468.468 0 00.436.277.498.498 0 00.456-.34c.014-.047.02-.951.02-2.714 0-2.617 0-2.643-.04-2.729a.453.453 0 00-.237-.242l-.096-.045H7.739c-2.638 0-2.663.001-2.748.04z',
                fill: 'currentColor',
            },
        },
    },
};
